import React from 'react';
import classnames from 'classnames';
import proptypes from 'prop-types';
import { Link, Typography } from '@one-thd/sui-atomic-components';

const { string, bool } = proptypes;

export const Text = ({
  boldText,
  normalText,
  linkText,
  url,
  hasBorder,
  wrapperClasses
}) => {
  const wrapperClassnames = classnames(wrapperClasses, {
    'sui-p-4 sui-border-solid sui-border-1 sui-border-primary sui-rounded-base': hasBorder
  });

  return (
    <div className={wrapperClassnames}>
      {!!boldText && (
        <Typography
          component="span"
          weight="bold"
          height="tight"
        >
          {boldText}
        </Typography>
      )}
      <Typography
        component="span"
        weight="regular"
        height="tight"
      >
        {normalText}
      </Typography>
      {!!linkText && (
        <Link
          href={url}
          target="_blank"
          weight="regular"
          underline="always"
          height="tight"
        >
          {linkText}
        </Link>
      )}
    </div>
  );
};

Text.propTypes = {
  boldText: string,
  normalText: string.isRequired,
  linkText: string,
  url: string,
  hasBorder: bool,
  wrapperClasses: string
};

Text.defaultProps = {
  boldText: '',
  linkText: '',
  url: '',
  hasBorder: false,
  wrapperClasses: ''
};
